<div class="field" [formGroup]="formGroup">
    <label class="inputLabel" [for]="id">{{label ? label : ""}}</label>
    <input [id]="id" [placeholder]="placeholder ? placeholder : ''" [formControlName]="id"
        [mask]="maskOptions != undefined && maskOptions.mask != undefined ? maskOptions.mask : ''" readonly />
    <form-error [id]="id" [formGroup]="formGroup"></form-error>
</div>